import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  users: [],
  user: {},
  roles: [],
  queues: [],
  agents: [],
  ramais: [],
  tags: [],
  conferencias: [],
  pesquisas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
